import type {
	BoundActions,
	HookActionsFunction,
	HookFunction,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		hasLivePageChanges: false,
	},
	actions: {
		setHasLivePageChanges:
			(
				hasLivePageChanges: boolean,
			): (({
				setState,
			}: StoreActionApi<{
				hasLivePageChanges: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({ hasLivePageChanges });
			},
	},
	name: 'live-page-invite-nudge-store',
});

export const useLivePageInviteNudgeStore: HookFunction<
	{
		hasLivePageChanges: boolean;
	},
	BoundActions<
		{
			hasLivePageChanges: boolean;
		},
		{
			setHasLivePageChanges: (hasLivePageChanges: boolean) => ({
				setState,
			}: StoreActionApi<{
				hasLivePageChanges: boolean;
			}>) => void;
		}
	>,
	void
> = createHook(Store);
export const useLivePageInviteNudgeActions: HookActionsFunction<
	BoundActions<
		{
			hasLivePageChanges: boolean;
		},
		{
			setHasLivePageChanges: (hasLivePageChanges: boolean) => ({
				setState,
			}: StoreActionApi<{
				hasLivePageChanges: boolean;
			}>) => void;
		}
	>
> = createActionsHook(Store);
